import { useLayoutEffect } from "react";
import { THEME_TYPE } from "@Constants/dataEnums";

export const useThemeController = ({themeType}) => {

    useLayoutEffect(() => {
            const body = document.body;

            if (themeType === THEME_TYPE.DARK) {
                body.classList.add('theme-dark');
            } else {
                body.classList.remove('theme-dark');
            }
        },
        [themeType]
    );
}